import { useEffect } from 'react';

const AppRedirect: React.FC = () => {
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            // iOS → Weiterleitung zum App Store
            window.location.href = 'https://apps.apple.com/de/app/managd/id6745959836';
        } else if (/android/i.test(userAgent)) {
            // Android → Weiterleitung zum Play Store
            window.location.href = 'https://play.google.com/store/apps/details?id=com.getmanagd.app';
        } else if (/Mac|Macintosh/.test(userAgent)) {
            // macOS Desktop → Weiterleitung zum App Store
            window.location.href = 'https://apps.apple.com/de/app/managd/id6745959836';
        } else if (/Win|Windows/.test(userAgent)) {
            // Windows Desktop → Weiterleitung zum Play Store
            window.location.href = 'https://play.google.com/store/apps/details?id=com.getmanagd.app';
        } else {
            // Fallback → z. B. deine Website
            window.location.href = 'https://www.getmanagd.com';
        }
    }, []);

    return <p>Du wirst weitergeleitet...</p>;
};

export default AppRedirect;
